export * from './MailReturnDetails'
